import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';
import CustomDropDownArray from '../../../../../utils/redux-forms-custom-fields/CustomDropDownArray';
import { WHITELIST_TYPE_OPTIONS } from '../../constants/options';

const WhiteList = ({ 
  fields,
  meta: { error },
  onRemove,
  questForm,
  parametersSubTab
}) => {
  const isYoutubeVideoQuest = questForm?.values?.type === 'youtube-video';

  const getWhiteListTypeOptions = () => {
    if (isYoutubeVideoQuest) {
      return WHITELIST_TYPE_OPTIONS.filter(
        option => option.value === 'noiz-username' || option.value === 'youtube-username'
      );
    }
    return WHITELIST_TYPE_OPTIONS;
  };
  const whiteListTypeOptions = getWhiteListTypeOptions();

  return (
    <section className="WhiteListWrapper">
      <ul>
        {fields.map((whiteListItem, index) => (
          <li key={index}>
            <section className="RepeaterWrapper__fields">
              <div className="item-number">{index}</div>
              <Field
                name={`${whiteListItem}.type`}
                id={`${whiteListItem}.type`}
                placeholder="Select type"
                customLabel="Type of Whitelisting"
                component={CustomDropDownArray}
                options={whiteListTypeOptions}
              />
              <Field
                name={`${whiteListItem}.identity`}
                id={`${whiteListItem}.identity`}
                type="text"
                component={CustomInput}
                label="Username"
                placeholder="Username"
                customLabel="Username"
              />
              <button
                className="RepeaterWrapper__item-remove"
                type="button"
                onClick={() => onRemove(fields, index)}
              >
                <i className="fa fa-trash" />
              </button>
            </section>
          </li>
        ))}
      </ul>
      
      {error && <span className="RepeaterWrapper__error">{error}</span>}
      
      <button 
        className="RepeaterWrapper__add-item" 
        type="button" 
        onClick={() => fields.push({})}
      >
        Add User to Whitelist
      </button>
    </section>
  );
};

WhiteList.propTypes = {
  fields: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  questForm: PropTypes.object.isRequired,
  parametersSubTab: PropTypes.number.isRequired
};

export default React.memo(WhiteList);